<template>
  <details-header :loading="loading">
    <template v-slot:avatar v-if="$vuetify.breakpoint.mdAndUp">
      <user-avatar :size="55" :user="profile"> </user-avatar>
    </template>
    <template v-slot:headerLine1>
      <span class="secondary--text">
        {{ profile.firstName }}'s Task Hub &#128221;
      </span>
    </template>
    <template v-slot:headerLine2>
      Increase your overall score by working through your tasks
    </template>
    <template v-slot:secondary>
      <v-row class="accent">
        <v-col cols="12" class="py-0">
          <v-container>
            <v-row>
              <v-col
                class="py-0"
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
              >
                <v-breadcrumbs
                  class="pa-0 font-weight-bold"
                  :items="breadcrumbList"
                >
                  <template v-slot:item="{ item }">
                    <v-breadcrumbs-item
                      exact
                      :class="item.to ? 'primary--text' : 'secondary--text'"
                      :to="item.to"
                    >
                      {{ item.text }}
                    </v-breadcrumbs-item>
                  </template>
                  <template v-slot:divider>
                    <v-icon color="secondary">keyboard_arrow_right</v-icon>
                  </template>
                </v-breadcrumbs>
              </v-col>
              <v-spacer> </v-spacer>
              <v-col cols="auto" class="py-0 secondary--text subtitle-2">
                <v-icon color="secondary" class="mr-2">query_builder</v-icon>
                Estimated time {{ time }} minutes
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </template>
    <template v-if="tasks.length > 0">
      <task-list
        v-on:select="selectTask"
        v-if="selectedTaskId == null"
      ></task-list>
      <template v-else>
        <task-details :taskId="selectedTaskId"></task-details>
        <v-footer app elevation="6">
          <v-container>
            <div class="text-center">
              <v-btn x-large color="performance" to="/tasks">
                Finish
              </v-btn>
            </div>
          </v-container>
        </v-footer>
      </template>
    </template>
    <v-row v-else>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="auto">
                <v-img :src="$images.EMPTY_TASK_HUB"> </v-img>
              </v-col>
              <v-col class="my-auto">
                <div class="text-h5 secondary--text font-weight-bold pb-2">
                  Super! Your task hub is empty
                </div>
                <div class="pb-2">
                  Great news! There aren't any additional tasks for you to
                  complete here. We'll message you when a task is added.
                </div>
                <v-btn color="primary" to="/" text class="ml-n4">
                  Go to your dashboard <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import taskTypes from "@/helpers/mixins/taskTypes";
import DetailsHeader from "@/components/common/DetailsHeader";
import TaskList from "@/components/tasks/TaskList";
import TaskDetails from "@/components/tasks/TaskDetails";
export default {
  name: "TaskDashboard",
  components: {
    DetailsHeader,
    TaskList,
    TaskDetails
  },
  mixins: [taskTypes],
  data: () => ({
    loading: false
  }),
  computed: {
    selectedTaskId() {
      return this.$route.params.id ? Number(this.$route.params.id) : null;
    },
    selectedTask() {
      return this.selectedTaskId != null
        ? this.tasks.find(x => x.type == this.selectedTaskId)
        : null;
    },
    time() {
      let self = this;
      if (this.selectedTask != null) {
        return self.getTaskTime(this.selectedTask);
      }
      return this._.sumBy(this.tasks, function(o) {
        return self.getTaskTime(o);
      });
    },
    breadcrumbList() {
      if (this.selectedTask) {
        return [
          { text: "All Tasks", to: "/tasks" },
          {
            text: this.getTaskTitle(this.selectedTask)
          }
        ];
      }
      return [{ text: "All Tasks" }];
    },
    ...mapGetters({
      profile: "profile/profile",
      settings: "profile/settings",
      tasks: "task/tasks"
    })
  },
  watch: {},
  created() {
    this.getTasks();
  },
  methods: {
    selectTask(type) {
      let link = `/tasks/${type}`;
      switch (type) {
        case this.$enums.taskTypes.ANNUAL_REVIEW_HR_SIGNOFF_NEEDED:
          link = "/reporting/annual-reviews/overview";
      }
      this.$router.push({ path: link });
    },
    getTasks() {
      if (this.selectedTaskId != null) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("task/getTasks")
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your tasks."
          );
        });
    }
  }
};
</script>
